import { render, staticRenderFns } from "./u-chip-flat-label.vue?vue&type=template&id=ee91aa2a&scoped=true&"
import script from "./u-chip-flat-label.vue?vue&type=script&lang=js&"
export * from "./u-chip-flat-label.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee91aa2a",
  null
  
)

export default component.exports